<template>
  <div class="userinfo-container">
    <el-form :inline="true" :model="filters">
      <el-form-item style="margin-bottom: 0px" label="所属企业">
        <tenantSelector
          style="width: 200px; height: 24px"
          v-model="filters.tenant"
          auto-complete="off"
        />
      </el-form-item>
      <el-form-item style="margin-bottom: 0px" label="关键字">
        <el-input
          size="small"
          v-model="filters.search"
          placeholder="关键词" clearable
          style="width: 200px"
          @keyup.native.enter="queryAll"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom: 0px" label="排序">
        <el-radio-group v-model="filters.orderby" size="small">
              <el-radio-button
                v-for="item in orders"
                :value="item.value"
                :key="item.value"
                :label="item.value"
                >{{ item.name }}</el-radio-button
              >
            </el-radio-group>
      </el-form-item>
     
      <el-form-item style="margin-bottom: 0px">
        <el-button size="small" type="primary" @click="queryAll"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table border :data="datas" style="width: 100%" size="small">
      <el-table-column
        prop="Code"
        label="岗位编码"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="岗位名称"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="SalaryDesc"
        label="薪资说明"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="Member.Mobile" label="招聘人电话" width="130"></el-table-column>
      <el-table-column prop="Member" label="招聘人" width="200">
        <template slot-scope="scope">
          <div>
            <img
              v-if="scope.row.Member.HeadImage"
              :src="
                scope.row.Member.HeadImage.indexOf('http') == 0
                  ? scope.row.Member.HeadImage
                  : baseUrl + scope.row.Member.HeadImage
              "
              :key="scope.row.Member.HeadImage"
              width="30"
            />
            <span>{{ scope.row.Member.RealName }}</span
              >
              <span v-if="scope.row.Tenant.Code!='HT'">@{{ scope.row.Tenant.Name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Enable" label="有效状态" width="150">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.Enable"
            @change="doSave(scope.row)"
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="AdHomeOrder" label="主页推荐位次" width="160">
        <template slot-scope="scope">
          <el-input-number
            size="small"
            v-model="scope.row.AdHomeOrder"
            @change="doSave(scope.row)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="AdChannelOrder" label="频道推荐位次" width="160">
        <template slot-scope="scope">
          <el-input-number
            size="small"
            v-model="scope.row.AdChannelOrder"
            @change="doSave(scope.row)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        prop="Desc"
        label="备注"
        show-overflow-tooltip
        min-width="120"
      ></el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleRemove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
  </div>
</template>
  <script>
import { getPageList, save, del } from "@/api/business/job.js";
import tenantSelector from "@/components/tenantSelector.vue";
export default {
  components: { tenantSelector },
  data() {
    return {
      orders:[{key:0,name:"发布时间",value:0},{key:1,name:"推荐位次",value:1},{key:2,name:"频道位次",value:2}],
      datas: [],
      filters: {
        search: "",
        tenant: "",
        orderby:0,
      },
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
      totalCount: 0,
    };
  },
  methods: {
    queryAll() {
      let param = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.filters.search,
        orderby:this.filters.orderby,
        tenant: this.filters.tenant ? this.filters.tenant.Key : "",
      };
      getPageList(param).then((res) => {
        this.datas = res.Items;
        this.totalCount = res.Total | res.Items.length;
      });
    },
    doSave(row) {
      save(row).then((res) => {
        if (res) {
          this.msg.successMsg("保存成功！");
        }
      });
    },
    handleRemove(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {
          key: row.Key,
        };
        del(param)
          .then((res) => {
            if (res) {
              this.queryAll();
            }
          })
          .catch((ex) => {});
      });
    },
    handleSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryAll());
    },
    handleCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.queryAll();
    },
  },
  mounted() {
    this.tabs = this.$config.tenantStatus;
    this.queryAll();
  },
};
</script>
  <style lang='scss' scoped>
.userinfo-container {
  padding: 10px;
}
/deep/.el-dialog {
  margin-top: 10px !important;
}
</style>